const initialState = { 
  loading: false,
  success: null,
  error: null
}

function rejectWithdrawalReducer(state = initialState, action) {
  switch (action.type) {
    case 'REJECT_WITHDRAWAL_BEGIN':
      return {
        ...state,
        loading: true,
        success: null,
        error: null
      }

    case 'REJECT_WITHDRAWAL_SUCCESS':
      return {
        ...state,
        loading: false,
        success: action.success
      }

    case 'REJECT_WITHDRAWAL_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }

    default: return state
  }
}

export default rejectWithdrawalReducer
